import Vue from 'vue'
import Router from 'vue-router'
import $api from '../services/axios'
import $self from '../services/store'

import layoutDefault from '@/components/layout/layout-default.vue'

Vue.use(Router)

var router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: layoutDefault,
      children: [
        {
          path: 'page-not-found',
          component: () => import('@/components/error/404.vue'),
          name: '404',
          meta: {
            title: 'ページが見つかりません',
          }
        },
        {
          path: 'page-not-found/for-client-survey',
          component: () => import('@/components/error/404-after-client-survey.vue'),
          name: '404-after-client-survey',
          meta: {
            title: 'ページが見つかりません',
          }
        },
        {
          path: 'page-not-found/for-cs-and-recruit',
          component: () => import('@/components/error/404-cs-and-recruit.vue'),
          name: '404-cs-and-recruit',
          meta: {
            title: 'ページが見つかりません',
          }
        },
        {
          path: 'page-not-found/for-retirement',
          component: () => import('@/components/error/404-retirement.vue'),
          name: '404-retirement',
          meta: {
            title: 'ページが見つかりません',
          }
        },
        {
          path: 'page-not-found/for-schedule',
          component: () => import('@/components/error/404-schedule.vue'),
          name: '404-schedule',
          meta: {
            title: 'ページが見つかりません',
          }
        },
        {
          path: 'after-entering-survey/:token',
          component: () => import('@/components/survey/after-entering-survey.vue'),
          name: 'after-entering-survey',
          meta: {
            title: 'ご入社後の状況アンケート調査',
            active: 'after-entering-survey'
          }
        },
        {
          path: 'cs-and-recruit/:token',
          component: () => import('@/components/survey/cs-and-recruit.vue'),
          name: 'cs-and-recruit',
          meta: {
            title: 'お客様満足度 / 採用計画に関するアンケート',
            active: 'cs-and-recruit'
          }
        },
        {
          path: 'retirement/:token',
          component: () => import('@/components/agreement-cancel/retirement.vue'),
          name: 'retirement',
          meta: {
            title: '返還条件ご確認のお願い',
            active: 'retirement'
          }
        },
        {
          path: 'order-confirm/:token',
          component: () => import('@/components/order/order-confirm.vue'),
          name: 'order-confirm',
          meta: {
            title: '求人確認',
            active: 'order-confirm'
          }
        },
        {
          path: 'schedule/:token',
          component: () => import('@/components/interview/schedule.vue'),
          name: 'schedule',
          meta: {
            title: '面接日程選択',
            active: 'schedule'
          }
        },
        {
         path: 'comp',
         component: () => import('@/components/common/comp.vue'),
         name: 'comp',
         meta: {
            title: '完了画面',
           active: 'comp'
         }
        },
        {
          path: 'comp-schedule',
          component: () => import('@/components/common/comp-schedule.vue'),
          name: 'comp-schedule',
          meta: {
            title: '面接日程確定画面',
            active: 'comp-schedule'
          }
        }
        ,
        {
          path: 'comp-reschedule',
          component: () => import('@/components/common/comp-reschedule.vue'),
          name: 'comp-reschedule',
          meta: {
            title: '面接日程再調整受付完了画面',
            active: 'comp-schedule'
          }
        }
      ]
    },
    {
      path: '/',
      component: () => import('@/career/components/layout/layout-full.vue'),
      children: [
        {
          path: 'career-page-not-found',
          component: () => import('@/components/error/404.vue'),
          name: 'career-404',
          meta: {
            title: 'ページが見つかりません',
          }
        },
        {
          path: 'career_mail/:token',
          component: () => import('@/career/components/career_mail/index.vue'),
          name: 'career-mail',
          meta: {
            title: 'メール配信停止'
          }
        }
      ]
    },
    {
      path: '*',
      redirect: '/page-not-found'
    },
    {
      path: '/maintenance',
      component: () => import('@/components/error/maintenance.vue'),
      name: 'maintenance',
      meta: {
        title: 'メンテナンス',
        active: 'maintenance'
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  // get config and check maintenance
  if (to.name !== 'maintenance') {
    $api.getConfig((data) => {
      $self.$config = data
      if ($self.$config.maintenance.open === true) {
        router.replace('/maintenance')
      }
    })
  }

  document.title = to.meta.title + ' | Geekly'
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js